import React from 'react';
import { FadeIn } from './FadeIn';
import { BookOpenIcon } from 'lucide-react';
export function Modules() {
  const tomos = [{
    num: '01',
    title: 'Fundamentos del Trail Running',
    desc: 'Una guía inicial para comprender qué es el trail running, cómo se diferencia del running tradicional, qué terrenos existen y cómo iniciar alumnos de distintos niveles de forma segura.'
  }, {
    num: '02',
    title: 'Técnica de Carrera en Trail Running',
    desc: 'Material práctico para enseñar y corregir la técnica en senderos, subidas, bajadas y terrenos irregulares, trabajando postura, apoyo, cadencia, mirada y equilibrio.'
  }, {
    num: '03',
    title: 'Planificación de Clases de Trail Running',
    desc: 'Estructuras de clases, objetivos de entrenamiento, planificación mensual, clases por niveles y modelos para armar sesiones completas sin improvisar.'
  }, {
    num: '04',
    title: 'Fuerza, Estabilidad y Prevención',
    desc: 'Ejercicios de fuerza, movilidad, propiocepción, estabilidad de tobillo, core y rutinas preventivas para reducir riesgos de lesiones frecuentes en montaña.'
  }, {
    num: '05',
    title: 'Entrenamientos Específicos para Trail',
    desc: 'Sesiones listas para mejorar resistencia, potencia, subidas, bajadas, fondos, cambios de ritmo y preparación para carreras de distintas distancias y niveles.'
  }, {
    num: '06',
    title: 'Gestión de Grupos y Venta de Clases',
    desc: 'Cómo organizar grupos, captar alumnos, fidelizar corredores, crear comunidad, vender programas de entrenamiento y profesionalizar tu servicio de trail running.'
  }];
  return <section className="py-24 px-4 bg-brand-dark relative overflow-hidden" data-id="element-40">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-41">
        <FadeIn className="text-center mb-20" data-id="element-42">
          <h2 className="text-brand-volt font-bold tracking-widest text-sm mb-4" data-id="element-43">
            EL SISTEMA PRINCIPAL
          </h2>
          <h3 className="text-5xl sm:text-6xl font-black text-white" data-id="element-44">
            LOS 6 TOMOS <br data-id="element-45" /> DEL MEGA PACK TRAIL
          </h3>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-46">
          {tomos.map((tomo, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-47">
              <div className="relative p-8 bg-brand-surface border border-brand-muted/20 hover:border-brand-volt transition-all group h-full" data-id="element-48">
                <div className="absolute top-4 right-4 text-6xl font-black text-brand-dark/50 group-hover:text-brand-volt/10 transition-colors pointer-events-none" data-id="element-49">
                  {tomo.num}
                </div>
                <BookOpenIcon className="w-8 h-8 text-brand-volt mb-6" data-id="element-50" />
                <h4 className="text-2xl font-bold text-white mb-4 pr-8" data-id="element-51">
                  {tomo.title}
                </h4>
                <p className="text-gray-400 leading-relaxed normal-case" data-id="element-52">
                  {tomo.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}